import { Spin } from "antd";

const Button = ({
  children,
  variant = "primary",
  fullWidth,
  onClick,
  loading = false,
  ...props
}: any) => {
  const variants = {
    primary: {
      backgroundColor: "#ffcc00",
      color: "#000",
      border: "none",
      padding: "12px 24px",
      borderRadius: "8px",
      fontWeight: "600",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      transition: "background 0.2s",
    },
    secondary: {
      backgroundColor: "#000",
      color: "white",
      border: "none",
      padding: "12px 24px",
      borderRadius: "8px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background 0.2s",
    },
    outline: {
      backgroundColor: "white",
      color: "#000",
      border: "1px solid #ddd",
      padding: "10px 16px",
      borderRadius: "8px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
    },
    ghost: {
      backgroundColor: "#e8e8e8",
      color: "#666",
      border: "none",
      padding: "12px 24px",
      borderRadius: "8px",
      fontWeight: "500",
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.2s",
    },
  };

  return (
    <button
      onClick={onClick}
      style={{
        ...(variants as any)[variant],
        width: fullWidth ? "100%" : "auto",
        opacity: props?.disabled ? "0.5" : "1",
        cursor: props?.disabled ? "not-allowed" : "pointer",
        transition: "500ms",
      }}
      {...props}
    >
      {loading && <Spin />} {children}
    </button>
  );
};

export default Button;
